module.exports = __webpack_public_path__ + "static/media/splash.5ada5829.png";